var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "70px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:#ffffff;}\r\n    @keyframes blink-animation {\r\n        0%, 100% { opacity: 1; }\r\n        50% { opacity: 0; }\r\n    }\r\n    .blink {\r\n        animation-name: blink-animation;\r\n        animation-duration: 2s;\r\n        animation-iteration-count: infinite;\r\n    }\r\n    .blink-slow {\r\n        animation-duration: 3s; /* Slower blink */\r\n    }\r\n    .blink-fast {\r\n        animation-duration: 1s; /* Faster blink */\r\n    }\r\n    .blink-delayed {\r\n        animation-duration: 2s;\r\n        animation-delay: 1s; /* Starts blinking after a delay */\r\n    }\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.773,51.613c-17.102,0-30.967,13.863-30.967,30.969c0,17.102,13.865,30.965,30.967,30.965 c17.104,0,30.969-13.863,30.969-30.965C183.742,65.476,169.877,51.613,152.773,51.613z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.613,
    y: 61.936,
    className: "st0 blink blink-slow",
    width: 41.289,
    height: 41.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.547,
    y: 61.936,
    className: "st0 blink blink-fast",
    width: 41.293,
    height: 41.291
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.773,275.613c-17.102,0-30.967,13.863-30.967,30.969c0,17.102,13.865,30.965,30.967,30.965 c17.104,0,30.969-13.863,30.969-30.965C183.742,289.476,169.877,275.613,152.773,275.613z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.613,
    y: 285.936,
    className: "st0 blink blink-delayed",
    width: 41.289,
    height: 41.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.547,
    y: 285.936,
    className: "st0 blink",
    width: 41.293,
    height: 41.291
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.953,224H276.645v-48h-41.289v48H78.047c-30.277,0-54.82,24.545-54.82,54.82v110.342h210.656l1.472,0.002 v45.982c-6.195,3.606-11.312,8.723-14.918,14.918H133.08l-0.711-0.002v0.002h-0.24v41.291h88.309 C227.59,503.644,240.754,512,256,512c15.244,0,28.41-8.356,35.562-20.644h88.309v-41.291h-88.309 c-3.606-6.195-8.723-11.312-14.918-14.918v-45.984h210.18l1.709,0.002v-0.002h0.24V278.82C488.773,248.545,464.231,224,433.953,224 z M55.227,278.82c0-12.584,10.236-22.82,22.82-22.82h355.906c12.584,0,22.82,10.236,22.82,22.82v78.342H55.227V278.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.953,0H78.047c-30.277,0-54.82,24.545-54.82,54.82V160H224h11.355h41.289H304h184.773V54.82 C488.773,24.545,464.231,0,433.953,0z M55.227,54.82c0-12.584,10.236-22.82,22.82-22.82h355.906c12.584,0,22.82,10.236,22.82,22.82 V128H55.227V54.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/SERVER.320272830f918dbf68a0fe6168eda758.svg";
export { ForwardRef as ReactComponent };